import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";

import {
    GetTrialGroupIdentityByIdRequest,
    type GetTrialGroupIdentityByIdResponse,
    type IReturn
} from "src/api/Tmd.dtos";
import useApi from "src/hooks/api/useApi";

/** Loads the authorized Group name for a Trial Group route. */
const useTrialGroupIdentityById = (
    id?: number | null,
    configuration?: SWRConfiguration<
        GetTrialGroupIdentityByIdResponse,
        GetTrialGroupIdentityByIdResponse
    >
) => {
    const getRequest = useMemo(
        () =>
            id
                ? (): IReturn<GetTrialGroupIdentityByIdResponse> =>
                      new GetTrialGroupIdentityByIdRequest({ id })
                : undefined,
        [id]
    );

    return useApi(
        "get",
        getRequest,
        {
            getData: (response?: SWRResponse<GetTrialGroupIdentityByIdResponse>) =>
                response?.data?.trialGroupIdentity,
            getError: (response?: SWRResponse<GetTrialGroupIdentityByIdResponse>) =>
                (response?.error ?? response?.data)?.responseStatus,
            getAdditionalState: () => ({})
        },
        configuration
    );
};

export default useTrialGroupIdentityById;
